import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// forms
import { Fieldset2 } from '../../../forms';
// ui
import { Box } from '../../../ui';
// feature load-board
import { saveTemplateFields, saveTemplateValidationSchema } from '../settings/save-template-form';
//////////////////////////////////////////////////

const enhance = compose(
  withFormik({
    enableReinitialize: true,
    displayName: 'SAVE_TEMPLATE_FORM',
    validationSchema: saveTemplateValidationSchema,
    mapPropsToValues: () => ({ templateName: null }),
    handleSubmit: (values, { props }) => props.submit(values),
  }),
  pure,
);

const SaveTemplateForm = enhance((props) => (
  <form onSubmit={props.handleSubmit}>
    <Fieldset2
      {...props}
      fields={saveTemplateFields}
      fieldsWrapperStyles={{ pt: 10 }}
    />
    <FormFooter />
  </form>
));

export default SaveTemplateForm;
